<script setup lang="ts"></script>

<template>
    <div class="container-fluid">
        <h1>{{ $Resources.InsightsDashboardMenuItem }}</h1>
    </div>
</template>
